module.exports = __webpack_public_path__ + "img/bana_1kl.0681e8ac.jpg";